var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#03a9f4",
    xmlns: "http://www.w3.org/2000/svg",
    width: "64px",
    height: "64px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    stroke: "#03a9f4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M69.1,28.9L55.9,15.7c-0.3-0.3-0.6-0.4-1-0.4c-0.8,0-1.4,0.6-1.4,1.4v10.6c0,2.2,1.8,4,4,4h10.6 c0.8,0,1.4-0.6,1.4-1.4C69.5,29.5,69.4,29.2,69.1,28.9z M69.5,39.3c0-1.1-0.9-2-2-2h-14c-3.3,0-6-2.7-6-6v-14c0-1.1-0.9-2-2-2h-20 c-3.3,0-6,2.7-6,6v48c0,3.3,2.7,6,6,6c0,0,18.7,0,20.3,0s2-1.1,1.9-2.8s-0.7-9,4.3-14.8s13.2-6.2,14.4-6.2c1.2,0,3.2-0.1,3.1-1.8 S69.5,39.3,69.5,39.3z M26.5,27.9l4.9-0.7c0.1,0,0.3-0.1,0.3-0.2l2.2-4.5c0.2-0.3,0.6-0.3,0.8,0l2.2,4.5c0.1,0.1,0.2,0.2,0.3,0.2 l4.9,0.7c0.3,0.1,0.5,0.5,0.2,0.7l-3.6,3.5c-0.1,0.1-0.1,0.2-0.1,0.4l0.8,4.9c0.1,0.3-0.3,0.6-0.6,0.4l-4.4-2.3 c-0.1-0.1-0.3-0.1-0.4,0l-4.4,2.3c-0.3,0.2-0.7-0.1-0.6-0.4l0.8-4.9c0-0.1,0-0.3-0.1-0.4l-3.6-3.5C26,28.4,26.2,28,26.5,27.9z M44.5,61.3c0,1.1-0.9,2-2,2h-13c-1.1,0-2-0.9-2-2v-2c0-1.1,0.9-2,2-2h13c1.1,0,2,0.9,2,2V61.3z M55.5,49.3c0,1.1-0.9,2-2,2h-24 c-1.1,0-2-0.9-2-2v-2c0-1.1,0.9-2,2-2h24c1.1,0,2,0.9,2,2V49.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3,56.2c-7.9,0-14.3,6.4-14.3,14.3s6.4,14.3,14.3,14.3s14.3-6.4,14.3-14.3S74.1,56.2,66.3,56.2z M68.8,71.8c-0.4,0-0.8-0.1-1.2-0.2L62.1,77c-0.4,0.4-0.8,0.5-1.2,0.5c-0.5,0-0.8-0.1-1.2-0.5c-0.6-0.6-0.6-1.7,0-2.4l5.5-5.5 C65.1,68.8,65,68.4,65,68c-0.2-2.5,1.8-4.8,4.3-4.8c0.4,0,0.8,0.1,1.2,0.2c0.2,0,0.2,0.2,0.1,0.4l-2.4,2.5c-0.2,0.1-0.2,0.5,0,0.6 l1.7,1.7c0.2,0.2,0.5,0.2,0.7,0l2.4-2.4c0.1-0.1,0.4-0.1,0.4,0.1c0.1,0.4,0.2,0.8,0.2,1.2C73.5,70,71.4,72,68.8,71.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesActive);
export default __webpack_public_path__ + "static/media/services_active.8643ee4dac716ad258e1d56d2869e94c.svg";
export { ForwardRef as ReactComponent };